import * as React from 'react';
import '../lightmode.css';

const LightStyle = () => <></>;

export default LightStyle;
